import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const ApprovalLevelsSummary = ({ t, approvalLevels }) => {
  return (
    <>
      {approvalLevels.map(level => {
        return (
          <Grid container spacing={1} key={level.approvalLevelId}>
            <Grid item xs={12} sm={4}>
              <strong> {t('Document.Decision.ApprovalLevels.ApprovalLevelType')} :</strong> <span>{level.approvalLevelTypeName}</span>
            </Grid>
            <Grid item xs={12} sm={8}>
              <strong>{t('Document.Decision.ApprovalLevels.Decision')} :</strong>{' '}
              {level.decisionType.decisionTypeId && (
                <span>
                  {level.decisionReasonId
                    ? t('Document.Decision.ApprovalLevels.DecisionMadeByOnDateWithReason', {
                        data: {
                          decision: level.decisionType.decisionTypeName || '',
                          personName: level.changedById ? t('By') + ' ' + level.changedByName : '',
                          time: t('DATE_FORMAT', { date: { value: level.decisionDate, format: 'DD MMMM YYYY HH:mm' } }),
                          reason: level.reason || 'The customer is not eligible according to the lending norms ongoing'
                        }
                      })
                    : t('Document.Decision.ApprovalLevels.DecisionMadeByOnDate', {
                        data: {
                          decision: level.decisionType.decisionTypeName || '',
                          personName: level.changedById ? t('By') + ' ' + level.changedByName : '',
                          time: t('DATE_FORMAT', { date: { value: level.decisionDate, format: 'DD MMMM YYYY HH:mm' } })
                        }
                      })}
                </span>
              )}
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

ApprovalLevelsSummary.propTypes = {
  t: PropTypes.func.isRequired,
  approvalLevels: PropTypes.array.isRequired
};

export default withTranslation()(ApprovalLevelsSummary);
